'use strict';

module.exports = '3.12.0';
